<template>
  <ion-card>
    <ion-card-content>
      <ion-item>
        <ion-label
          position="floating"
        >
          Release track
        </ion-label>
        <ion-select-vue
          v-model="selectedReleaseTrack"
          interface="popover"
        >
          <ion-select-option
            v-for="track in releaseTrack"
            :key="track.key"
            :value="track.value"
          >
            {{ track.key }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>
    </ion-card-content>

    <ion-card-footer>
      <ion-button 
        expand="full"
        :disabled="busy"
        @click="save"
      >
        <ion-spinner v-if="busy" />
        <template v-else>
          Save
        </template>
      </ion-button>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { IonSelectVue, modalController } from '@modus/ionic-vue'
import { releaseTrack } from '../../releases/releaseTrack';
import router from '../../router'
import store from '../../state'

export default {
  components: {
    IonSelectVue
  },
  props: {
    currentReleaseTrack: {
      type: String,
      default: 'production'
    }
  },
  data() {
    return {
      busy: false,
      selectedReleaseTrack: this.currentReleaseTrack,
      releaseTrack,
    }
  },
  methods: {
    save() {
      const serialNumber = router.currentRoute.params.serialNumber

      this.busy = true

      store.dispatch('changeReleaseTrack', {
        serialNumber,
        releaseTrack: this.selectedReleaseTrack
      })
        .then(() => modalController.dismiss())
        .finally(() => this.busy = false)
    },
  },
}
</script>

<style scoped>
ion-card {
  margin:0;
}
</style>

<style>
.pin-to-version-modal .modal-wrapper {
  background:none;
}
</style>